import { AbstractControl } from "@angular/forms";
import { IUploadFile } from "../../common/services/document-management.service";

export enum DataCorrectionArrayEventOperation {
    AddNewItem = 0,
    RemoveCurrentItem = 1,
}

export interface DataCorrectionArrayEvent {
    correctionModel?: CorrectionModel;
	operation: DataCorrectionArrayEventOperation;
}

export interface CorrectionModel {
    propertyId?: string;
    propertyName?: string;
    propertyDisplayName?: string;
    propertyType?: string;
    propertyAllowEdit?: boolean;
    propertyIsOrganizationId?: boolean;
    propertyDataSource?: string;
    propertyValue?: any;
	propertyFormat?: string;
	itemIsDeleted?: boolean;
	itemIsAdded?: boolean;
    childCorrectionModels?: CorrectionModel[];
    arrayChildCorrectionModelFormat?: CorrectionModel;
}

export interface DataCorrectionStepDate {
    date?: Date;
    userId?: string;
    userName?: string;
}

export interface DataCorrectionInstance {
    id?: string;
    entityId?: string;
    entityName?: string;
    entityCollectionName?: string;
    entityPartitionKeyValue?: string;
    entityReviewGroupId?: string;
    externalRequestApplicationId?: string;
    objectId?: string;
    objectOrganizationId?: string;
    objectOrganizationName?: string;
    updatedFields?: CorrectionModel[];
    originalObject?: any;
    updatedObject?: any;
    uploadedFiles?: IUploadFile[];
    notes?: string;
    reviewNotes?: string;
    createdDate?: DataCorrectionStepDate;
    lastModifiedDate?: DataCorrectionStepDate;
    submittedDate?: DataCorrectionStepDate;
    approvedDate?: DataCorrectionStepDate;
    deniedDate?: DataCorrectionStepDate;
    returnedDate?: DataCorrectionStepDate;
    status?: DataCorrectionInstanceStatus;
}

export interface DataCorrectionInstanceIndex {
    dataCorrectionInstanceId: string;
    entityId: string;
    entityName: string;
    entityReviewGroupId: string;
    externalRequestApplicationId?: string;
    objectId: string;
    objectOrganizationId: string;
    objectOrganizationName?: string;
    createdDate?: Date;
    createdByUserId: string;
    createdByUserName: string;
    lastModifiedDate?: Date;
    lastModifiedByUserId: string;
    lastModifiedByUserName: string;
    submittedDate?: Date;
    submittedByUserId: string;
    submittedByUserName: string;
    approvedDate?: Date;
    approvedByUserId: string;
    approvedByUserName: string;
    deniedDate?: Date;
    deniedByUserId: string;
    deniedByUserName: string;
    returnedDate?: Date;
    returnedByUserId: string;
    returnedByUserName: string;
    status?: DataCorrectionInstanceStatus;
    assignedToUserId?: string;
}

export interface DataCorrectionInstanceIndexSearchSpec {
    createdByUserId: string;
    dataCorrectionInstanceId?: string;
    organizationId?: string;
    entityId?: string;
    objectId?: string;
    entityReviewGroupIds?: string[];
    externalRequestApplicationId?: string;
}

export enum DataCorrectionInstanceStatus {
    NotSubmitted = 'Not Submitted',
    PendingReview = 'Pending Review',
    ReturnedForCorrections = 'Returned For Corrections',
    Denied = 'Denied',
    Approved = 'Approved',
}
 

